module.exports = __webpack_public_path__ + "static/img/bg_blur03.17fefe2f.jpg";